import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserMessageThreadComponent } from '../user-message-thread/user-message-thread.component';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
})
export class ChatModalComponent implements OnInit, AfterViewInit {
  @ViewChild('chatModalTemplate') modalTemplate: any;
  @ViewChild(UserMessageThreadComponent)
  messageThread: UserMessageThreadComponent;

  modalRef!: NgbModalRef;

  constructor(public modalService: NgbModal) {}

  openModal() {
    this.modalRef = this.modalService.open(this.modalTemplate, {
      windowClass: 'modal-custom-lg',
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}
}
